import React, { useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import ModalComponent from '../../../components/modals'
import CustomSnackbar from '../../../components/snackbar'
import { callApiAsync, getExternalSurveyAnswerById } from '../../../services/apiService'
import { toYMD, formatCustomDateNameLocal } from '../../../utils/dateUtils'

const ViewSurveyResultsModal = ({ open, handleClose, answerId }) => {
    const [loading, setLoading] = useState(false)
    const [surveyData, setSurveyData] = useState(null)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')

    useEffect(() => {
        if (open && answerId) {
            loadSurveyResults()
        } else if (!open) {
            setSurveyData(null)
        }
    }, [open, answerId])

    const loadSurveyResults = async () => {
        setLoading(true)
        await callApiAsync(
            () => getExternalSurveyAnswerById(answerId),
            (resp) => {
                const data = resp?.data ?? resp
                setSurveyData(data)
                setLoading(false)
            },
            () => {

            }
        )
    }

    return (
        <>
            <ModalComponent
                open={open}
                handleClose={handleClose}
                title="RESULTADOS DE ENCUESTA CLIENTE INTERNACIONAL"
                width="90%"
                maxWidth="900px"
            >
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>Cargando resultados...</p>
                    </div>
                ) : !surveyData ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>No se encontraron resultados</p>
                    </div>
                ) : (
                    <div style={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px' }}>
                        <div className="mb-20">
                            <div style={{
                                border: '2px solid #6C5CE7',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '20px',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <h2 className="title-bio-details-chard" style={{
                                    marginBottom: '12px',
                                    color: '#6C5CE7',
                                    fontSize: '16px'
                                }}>
                                    Resultados de la Encuesta
                                </h2>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        {surveyData.clientName && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Cliente: <strong>{surveyData.clientName}</strong>
                                            </p>
                                        )}
                                        {surveyData.country && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                País: <strong>{surveyData.country}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderNumber && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Número de Orden: <strong>{surveyData.orderNumber}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.origin && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Destino/Origen: <strong>{surveyData.orderInfo.origin}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.product && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Producto: <strong>{surveyData.orderInfo.product}</strong>
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {surveyData.orderInfo?.transportMode && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Modalidad de transporte: <strong>{surveyData.orderInfo.transportMode}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.departureDateProvider && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Fecha salida origen: <strong>{formatCustomDateNameLocal(toYMD(surveyData.orderInfo.departureDateProvider))}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.arrivalDateCustoms && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Fecha llegada aduanas: <strong>{formatCustomDateNameLocal(toYMD(surveyData.orderInfo.arrivalDateCustoms))}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.arrivalDateClientFacilities && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Fecha llegada instalaciones cliente: <strong>{formatCustomDateNameLocal(toYMD(surveyData.orderInfo.arrivalDateClientFacilities))}</strong>
                                            </p>
                                        )}
                                        {surveyData.orderInfo?.transitTime != null && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Tiempo en tránsito: <strong>{surveyData.orderInfo.transitTime} días</strong>
                                            </p>
                                        )}
                                        {surveyData.responseDate && (
                                            <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '5px' }}>
                                                Fecha de Respuesta: <strong>{formatCustomDateNameLocal(toYMD(surveyData.responseDate))}</strong>
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </div>

                            <Grid container spacing={2}>
                                {surveyData.questionsWithAnswers && surveyData.questionsWithAnswers.map((item) => (
                                    <Grid item xs={12} key={item.questionNumber}>
                                        <div style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            backgroundColor: '#fff'
                                        }}>
                                            <p className="select-form-label" style={{
                                                color: '#6C5CE7',
                                                fontWeight: 'bold',
                                                marginBottom: '10px',
                                                fontSize: '16px'
                                            }}>
                                                Pregunta {item.questionNumber}
                                            </p>
                                            <p className="detail-label" style={{
                                                marginBottom: '15px',
                                                fontSize: '14px',
                                                color: '#333'
                                            }}>
                                                {item.questionText}
                                            </p>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '10px',
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: '5px'
                                            }}>
                                                <span style={{ fontWeight: 'bold', color: '#6C5CE7' }}>
                                                    Respuesta:
                                                </span>
                                                <span style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {item.answer}/10
                                                </span>
                                            </div>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </div>
                )}
            </ModalComponent>

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </>
    )
}

export default ViewSurveyResultsModal
